module.exports = __webpack_public_path__ + "static/media/prinz-eugen-win.f002f588.png";